var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 640,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "products",
      "label": "产品范围"
    }
  }, [_c('CheckboxGroup', {
    on: {
      "on-change": _vm.handleCheckChange
    },
    model: {
      value: _vm.data.products,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "products", $$v);
      },
      expression: "data.products"
    }
  }, _vm._l(_vm.products, function (c, index) {
    return _c('Checkbox', {
      key: index,
      attrs: {
        "label": c.id
      }
    }, [_vm._v(_vm._s(c.product_name))]);
  }), 1)], 1)], 1), _c('Checkbox', {
    staticStyle: {
      "margin-left": "100px"
    },
    attrs: {
      "indeterminate": _vm.indeterminate,
      "value": _vm.checkAll
    },
    nativeOn: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleCheckAll.apply(null, arguments);
      }
    }
  }, [_vm._v("全选")]), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };